import firebase from '../Firebase'

const { REACT_APP_MY_ENV, REACT_APP_CONFIG } = process.env

export const getToken = async () => {
  return new Promise((resolve, reject) => {
    firebase?.currentUser
      ?.getIdToken(true)
      .then(idToken => {
        resolve(idToken)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getBFFUrl = () => {
  if (REACT_APP_CONFIG === 'local') {
    switch (REACT_APP_MY_ENV) {
      case 'demo-mastercard-portal-dev':
        return 'http://localhost:3000/dev'
      case 'demo-mastercard-portal-tests':
        return 'http://localhost:3000/tests'
      default:
        return ''
    }
  }

  return `https://${REACT_APP_MY_ENV}.api.ubirider.com`
}

console.log(REACT_APP_MY_ENV, REACT_APP_CONFIG, getBFFUrl())
